import {PlaceDetails} from "../models/";

export class PlacesController {

  // =========================
  // 🔹 AUTOCOMPLETE / PREDICTIONS
  // =========================

  async fetchPlacePredictions(input: string, countryCode?: string, position?: google.maps.LatLng) {
    if (!input) {
      return [];
    }

    const { AutocompleteSuggestion } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;

    try {
      const request: google.maps.places.AutocompleteRequest = {
        input: input
      };

      if (countryCode && position) {
        request.locationBias = {
          radius: 0,
          center: { lat: position.lat(), lng: position.lng() }
        };
      }

      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
      return suggestions;
    } catch (err) {
      console.error("autocomplete failed", err);
      return [];
    }
  }

  // =========================
  // 🔹 RESULTS MAPPING
  // =========================

  async buildPlacesResults(input: string, countryCode?: string, position?: google.maps.LatLng | undefined): Promise<PlaceDetails[]> {
    const suggestions = await this.fetchPlacePredictions(input, countryCode, position);

    return suggestions
      .map(s => s.placePrediction)
      .filter(Boolean)
      .filter(prediction => {
        const types = prediction!.types || [];
        return !(types.includes("country") && !types.includes("locality"));
      })
      .map(prediction => ({
        id: prediction!.placeId,
        placeId: prediction!.placeId,
        headline: prediction!.text?.text ?? "",
        address_line_1: "",
        address_line_2: "",
        lat: undefined,
        lng: undefined,
        isGooglePlace: true
      }));
  }

  // =========================
  // 🔹 PLACE DETAILS
  // =========================

  async getPlaceDetails(placeId: string) {
    const {Place} = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;

    const place = new Place({
      id: placeId,
    });

    await place.fetchFields({
      fields: [
        "location",
        "viewport",
        "displayName",
        "formattedAddress",
      ],
    });

    return place;
  }
}